var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6137 20.0658C2.34081 15.6946 2.56818 10.8873 5.55332 7.60599C8.62703 4.22731 14.4091 2.70407 21.5579 4.70574C21.8304 4.78204 22.0434 4.99499 22.1197 5.26748C24.1212 12.4164 22.598 18.1984 19.2193 21.272C15.938 24.2572 11.1307 24.4845 6.75947 21.2117L4.66036 23.3108C4.34396 23.6272 3.83099 23.6272 3.51458 23.3108C3.19819 22.9944 3.19819 22.4814 3.51458 22.165L5.6137 20.0658ZM13.6664 9.45068C13.9937 9.04149 14.6422 9.27823 14.6422 9.80694V12.169H16.2317C16.6957 12.169 16.9513 12.7205 16.6574 13.0879L13.4177 17.1376C13.0904 17.5468 12.4419 17.3101 12.4419 16.7813V14.4193H10.8525C10.3884 14.4193 10.1328 13.8678 10.4267 13.5005L13.6664 9.45068Z",
    fill: "#FF7926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPower);
export default __webpack_public_path__ + "static/media/green-power.8ed0248f0bdb2e73e1b8809e17e86f17.svg";
export { ForwardRef as ReactComponent };